import * as Errors from "@baseline/common/errors";
import { ClassRef } from "@baseline/common/types";


export interface ErrorInfo
{
    type?: string;
    message: string;
    innerError?: ErrorInfo;
}


export namespace ErrorInfo
{
    export function isErrorInfo(value: unknown): value is ErrorInfo
    {
        if (typeof value != "object")
            return false;

        if (typeof value["message"] != "string")
            return false;

        return true;
    }

    export function getError(errorInfo: ErrorInfo): Error
    {
        const { type, message, innerError: innerErrorInfo } = errorInfo;
        const errorType: ClassRef<Error> = Errors[type] ?? Error;
        const innerError = innerErrorInfo && getError(innerErrorInfo);
        const error = new errorType(message, innerError);
        return error;
    }

    export function getInfo(error: any, devMode?: boolean): ErrorInfo
    {
        const message = error?.message ?? error?.toString() ?? "Unknown error";
        const stack =
            (devMode) &&
            (error instanceof Error) &&
            error.stack?.split("\n")
                .map(line => line.trim())
                .filter(line => line.startsWith("at "));

        const innerError = devMode && error?.innerError && getInfo(error?.innerError, devMode);

        return (
            {
                message,
                ...(stack && { stack }),
                ...(innerError && { innerError })
            }
        );
    }
}